export default {"src":"/_next/static/media/procision_logo_title_dark.df5ff7c9.svg","height":320,"width":2130,"blurWidth":0,"blurHeight":0};